"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CONTAINER = exports.USER_DETAILS_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    USER_DETAILS_CONTAINER = (0, _cxs["default"])({
  display: "flex",
  width: "33%",
  alignItems: "center",
  justifyContent: "center",
  " > .image": {
    marginRight: "20px"
  }
});

exports.USER_DETAILS_CONTAINER = USER_DETAILS_CONTAINER;
var CONTAINER = (0, _cxs["default"])({
  flex: 1
});
exports.CONTAINER = CONTAINER;